import { render, staticRenderFns } from "./BcbExamCalendar.vue?vue&type=template&id=06ede2ba&scoped=true"
import script from "./BcbExamCalendar.vue?vue&type=script&lang=js"
export * from "./BcbExamCalendar.vue?vue&type=script&lang=js"
import style0 from "./BcbExamCalendar.vue?vue&type=style&index=0&id=06ede2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ede2ba",
  null
  
)

export default component.exports